export enum Role {
    PRODUCT_READER = "PRODUCT_READER",
    PRODUCT_WRITER = "PRODUCT_WRITER",
    PRODUCT_APPROVE = "PRODUCT_APPROVE",
    DEAL_TERMS_READER = "DEAL_TERMS_READER",
    DEAL_TERMS_WRITER = "DEAL_TERMS_WRITER",
    LICENSES_READER = "LICENSES_READER",
    LICENSES_WRITER = "LICENSES_WRITER",
    CUSTOMER_READER = "CUSTOMER_READER",
    CUSTOMER_WRITER = "CUSTOMER_WRITER",
    CUSTOMER_CONTACTS_READER = "CUSTOMER_CONTACTS_READER",
    CUSTOMER_CONTACTS_WRITER = "CUSTOMER_CONTACTS_WRITER",
    CUSTOMER_CONTENT_SPEC_READER = "CUSTOMER_CONTENT_SPEC_READER",
    CUSTOMER_CONTENT_SPEC_WRITER = "CUSTOMER_CONTENT_SPEC_WRITER",
    CUSTOMER_TECH_SPEC_READER = "CUSTOMER_TECH_SPEC_READER",
    CUSTOMER_TECH_SPEC_WRITER = "CUSTOMER_TECH_SPEC_WRITER",
    CUSTOMER_TECH_PROFILE_READER = "CUSTOMER_TECH_PROFILE_READER",
    CUSTOMER_TECH_PROFILE_WRITER = "CUSTOMER_TECH_PROFILE_WRITER",
};
